import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LOGIN } from "@/constants/testIds";
import { Link } from "react-router-dom";

export function LoginForm({ email, password, loading, onEmailChange, onPasswordChange, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div>
        <Label htmlFor="email" className="text-zinc-500 text-xs uppercase tracking-wide">Email</Label>
        <Input
          id="email" type="email" required value={email} onChange={(e) => onEmailChange(e.target.value)}
          data-testid={LOGIN.emailInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div>
        <Label htmlFor="password" className="text-zinc-500 text-xs uppercase tracking-wide">Password</Label>
        <Input
          id="password" type="password" required value={password} onChange={(e) => onPasswordChange(e.target.value)}
          data-testid={LOGIN.passwordInput}
          className="bg-white border-zinc-300 text-zinc-950 focus:border-zinc-950 focus:ring-1 focus:ring-[#4FD1C5] rounded-none mt-1"
        />
      </div>
      <div className="text-right">
        <Link to="/forgot-password" data-testid={LOGIN.forgotPasswordLink} className="text-xs text-zinc-500 hover:text-zinc-950">
          Forgot password?
        </Link>
      </div>
      <Button type="submit" disabled={loading} data-testid={LOGIN.submitButton} className="w-full bg-zinc-950 text-white font-medium rounded-none hover:bg-zinc-900 hover:shadow-[0px_4px_0px_0px_#4FD1C5]">
        {loading ? "Logging in..." : "Log In"}
      </Button>
    </form>
  );
}
